// extracted by mini-css-extract-plugin
export var label = "_de-2";
export var slideContainer = "_de-0";
export var slider = "_de-1";